/* @flow */

import { mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'relative',

    paddingBottom: 2,

    color: mediumGrey,

    lineHeight: 18 / baseFontSize,
    textDecoration: 'none',
    WebkitFontSmoothing: 'antialiased',

    '&:visited': {
      color: mediumGrey,
    },
    '&:hover': {
      color: mediumGrey,
    },
    '&:active': {
      color: mediumGrey,
    },
  },
  border: {
    position: 'absolute',
    left: 0,
    bottom: 0,

    display: 'block',
    width: 0,
    height: 1,

    backgroundColor: ({ accentColor }: Object) => accentColor,

    transition: 'width 0.2s ease-out',

    '$root:hover &': {
      width: '100%',
    },
    '$root:active &': {
      width: '100%',
    },
  },
};
